import React from 'react';
import { todayKey, yesterdayKey } from '../utils/dates';

export default function DateFilterBar({ selectedDay, onChange, showAll = false }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      {showAll && (
        <button
          type="button"
          className={`btn btn-sm ${selectedDay === 'all' ? 'btn-green' : 'btn-ghost'}`}
          onClick={() => onChange('all')}
        >
          All days
        </button>
      )}
      <button
        type="button"
        className={`btn btn-sm ${selectedDay === todayKey() ? 'btn-green' : 'btn-ghost'}`}
        onClick={() => onChange(todayKey())}
      >
        Today
      </button>
      <button
        type="button"
        className={`btn btn-sm ${selectedDay === yesterdayKey() ? 'btn-green' : 'btn-ghost'}`}
        onClick={() => onChange(yesterdayKey())}
      >
        Yesterday
      </button>
      <input
        type="date"
        value={selectedDay === 'all' ? todayKey() : selectedDay}
        max={todayKey()}
        onChange={(e) => e.target.value && onChange(e.target.value)}
        style={{
          padding: '8px 12px',
          borderRadius: 8,
          border: '1px solid var(--border2)',
          background: 'var(--card)',
          color: 'var(--text)',
          fontFamily: 'JetBrains Mono, monospace',
          fontSize: 12,
        }}
      />
    </div>
  );
}
